export type FilterSupportedType = StringValueId;

export class StringValueId {
  id: string;
  value: string;
  imgURL: string;
  //AWM-CP
  defaultValue: string;
  toolTipKey: string;
}
